// This file is generated by a script. Do not edit this file directly.
var _excluded = ["children", "variant", "className", "disabled", "href"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { cva } from 'cva';
var textLinkClasses = cva({
  base: 'cop-flex cop-items-center cop-gap-1.5 outline-none cop-outline-solid cop-outline-link cop-outline-offset-[3px] cop-w-fit cop-underline-offset-[3px] cursor-pointer',
  variants: {
    variant: {
      "default": 'cop-text-link cop-no-underline hover:cop-text-link-hover active:cop-text-link-active',
      secondary: 'cop-text-primary cop-underline',
      minimal: 'cop-text-secondary cop-no-underline cop-underline hover:cop-underline active:cop-underline'
    },
    disabled: {
      "true": 'cop-pointer-events-none'
    }
  },
  compoundVariants: [{
    variant: 'default',
    disabled: true,
    className: 'cop-text-link-disabled'
  }, {
    variant: 'secondary',
    disabled: true,
    className: 'cop-opacity-[0.45]'
  }, {
    variant: 'minimal',
    disabled: true,
    className: 'cop-opacity-[0.45]'
  }]
});
export function TextLink(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    href = _ref.href,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("a", _extends({}, props, disabled ? {
    'aria-disabled': 'true'
  } : {
    href: href
  }, {
    className: textLinkClasses({
      variant: variant,
      className: className,
      disabled: disabled
    }),
    "data-cop-text-link": true // Used to exclude this component from certain styles in the webapp
  }), children);
}
